import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { universalStyles, white } from '../../../../app/theme';
import { BASE_URL, IMAGE_PATHS } from '../../../../constants/paths.constants';
import CaseStudyRow from '../../../micro/caseStudy/CaseStudyRow';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  heading: {
    marginTop: 46,
  },
  yellowHeader: {
    marginBottom: 20,
  },
  headerRow: {
    marginTop: 40,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  header: {
    color: white,
    fontSize: 24,
  },
  icon: {
    width: 35,
    height: 'auto',
    marginRight: 15,
  },
  whiteText: {
    color: white,
  },
  caseStudy: {
    marginBottom: 30,
    '&:last-of-type': {
      margin: 0,
    },
  },
}));

type AcquisitionPage11Props = {
  setNextDisabledCS: (disabled: boolean) => void;
};

const AcquisitionPage11 = ({ setNextDisabledCS }: AcquisitionPage11Props): JSX.Element => {
  const classes = useStyles();
  const [completedSet, setCompletedSet] = useState(new Set());

  const setOneComplete = (page: number) => {
    const compareSet = [1, 2, 3, 4];
    const newSet = completedSet.add(page);
    setCompletedSet(newSet);
    const hasAll = compareSet.filter((item) => !completedSet.has(item));
    if (!hasAll.length) {
      setNextDisabledCS(false);
    }
  };

  return (
    <>
      <Typography variant="h6" className={classes.yellowHeader}>
        Please click on each of the case study examples below to learn more about evaluating a patient who has been
        administered Axumin. You must explore each case study below before you can advance to complete your training.
      </Typography>
      <Typography variant="body1" className={classes.whiteText}>
        <b>Disclaimer: </b>
        These case studies are provided as examples of the interpretation and utility of Axumin
        <sup>®</sup>
        (fluciclovine F 18) injection PET/CT imaging results. Axumin is not indicated for directing or changing patient
        management. Such decisions must be based on the independent medical judgment of the physician(s) responsible for
        the individual patient’s management.
      </Typography>
      <div className={classes.headerRow}>
        <img
          className={classes.icon}
          src={`${BASE_URL}${IMAGE_PATHS.CASE_STUDY[1].CASE_STUDY_ICON.path}`}
          alt={IMAGE_PATHS.CASE_STUDY[1].CASE_STUDY_ICON.alt}
        />
        <Typography className={classes.header}>Case Studies</Typography>
      </div>
      <div className={classes.grayBox}>
        <div className={classes.caseStudy}>
          <CaseStudyRow
            trainingId={1}
            module="axuminAcquisition"
            page={11}
            index={0}
            setNextDisabledCS={() => setOneComplete(1)}
          />
        </div>
        <div className={classes.caseStudy}>
          <CaseStudyRow
            trainingId={1}
            module="axuminAcquisition"
            page={11}
            index={1}
            setNextDisabledCS={() => setOneComplete(2)}
          />
        </div>
        <div className={classes.caseStudy}>
          <CaseStudyRow
            trainingId={1}
            module="axuminAcquisition"
            page={11}
            index={2}
            setNextDisabledCS={() => setOneComplete(3)}
          />
        </div>
        <div className={classes.caseStudy}>
          <CaseStudyRow
            trainingId={1}
            module="axuminAcquisition"
            page={11}
            index={3}
            setNextDisabledCS={() => setOneComplete(4)}
          />
        </div>
      </div>
    </>
  );
};

export default AcquisitionPage11;
